import React from "react";

const PrevArrowIcon = () => (
  <svg
    aria-hidden="true"
    focusable="false"
    width="36"
    height="12"
    viewBox="0 0 36 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="5.65692"
      y="-0.0000762939"
      width="1"
      height="8"
      rx="0.5"
      transform="rotate(45 5.65692 -0.0000762939)"
      fill="#212326"
    />
    <rect
      x="6.36395"
      y="10.6073"
      width="1"
      height="8"
      rx="0.5"
      transform="rotate(135 6.36395 10.6073)"
      fill="#212326"
    />
    <rect
      x="1.00067"
      y="6.31438"
      width="1"
      height="35"
      rx="0.5"
      transform="rotate(-90 1.00067 6.31438)"
      fill="#212326"
    />
  </svg>
);

export default PrevArrowIcon;
